import React from 'react';
import PropTypes from 'prop-types';

const VenueFeaturesSNoData = ({ id }) => {
	return (
		<div className="prfl-node-border" id={id}>
			<div className="prfl-empty-title">
				{t('Описание заведения не добавлено')}
			</div>
			<div className="prfl-empty-desc">
				<div className="prfl-empty-line" />
				<div className="prfl-empty-line" />
			</div>
			<div className="prfl-node-separator" />
			<div className="prfl-empty-title">
				{t('Особенности не указаны')}
			</div>
			<div className="prfl-empty-desc">
				<div className="prfl-empty-line" />
				<div className="prfl-empty-line" />
			</div>
		</div>
	);
};

VenueFeaturesSNoData.propTypes = {
	id: PropTypes.string,
};

VenueFeaturesSNoData.defaultProps = {
	id: undefined,
};

export default VenueFeaturesSNoData;
